import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import { People as PeopleIcon } from '@mui/icons-material';

import { MenuItem } from 'types/global';

type UsersProps = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function Candidates({ selected, onSelect, open }: UsersProps) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/candidates"
			selected={selected === MenuItem.Candidates}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.Candidates)}
		>
			<ListItemIcon>
				<PeopleIcon />
			</ListItemIcon>
			{open && <ListItemText primary={t('common:candidates')} />}
		</ListItem>
	);
}
